import type { IApplication } from '../../core/src/editor/services/application/common/application.js';

/** A ChatGPT Website tab stays live while its source page or Inspector popup is in use. */
export function isLiveInspectionActive(source: Document, popups: readonly Window[]): boolean {
    return source.visibilityState === 'visible' || popups.some(popup =>
        !popup.closed && popup.document.visibilityState === 'visible' && popup.document.hasFocus());
}

export function createLiveInspectionActivity(app: Pick<IApplication, 'windowsMainService'>, source: Document, home: Window): () => boolean {
    return () => isLiveInspectionActive(source, app.windowsMainService.getWindows()
        .map(editorWindow => editorWindow.getWindow()).filter(view => view !== home));
}
